// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-tips[data-v-65595153] {\n  text-align: center;\n  line-height: 1.5;\n}\n.pop-tips .title[data-v-65595153] {\n  font-size: 14px;\n  color: #2F3030;\n}\n.pop-tips .hot[data-v-65595153] {\n  color: #D6223D;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
